import * as serviceContext from '../services/serviceContext';
// import * as constants from '../configs/const';
import qs from 'qs'

var options = {};
var headers = new Headers();

headers.append('Content-Type', 'application/json');
options.headers = headers;

export async function signin(userData) {
    try {
        const response = await serviceContext.post("affiliate/auth/authenticate", qs.stringify(userData), options);
        // const response = await serviceContext.post("affiliate/Auth/Authenticate", userData, options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function velidateToken() {
    try {
        const response = await serviceContext.get("affiliate/auth/validatetoken", null, options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function getUserToken(token) {
    try {
        const response = await serviceContext.get("sso/token/" + token , null, options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function signUpAffiliate(userData) {
    try {
        const response = await serviceContext.post("affiliate/signup", JSON.stringify(userData), options);
        if(response.hasError === true){
            return false;
        }
        else{
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function checkIfUserExists(data) {
    try {
        const response = await serviceContext.get(`affiliate/signup/checkusername/${data}`, null, options);
        if(response.hasError === true){
            return false;
        }
        else{
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function checkIfMobileExists(data) {
    try {
        const response = await serviceContext.get(`affiliate/signup/checkmobile/${data}`, null, options);
        if(response.hasError === true){
            return false;
        }
        else{
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};


export async function forgotPasswordApi(userData) {
    try {
        const response = await serviceContext.post("affiliate/forgetpassword/sendotp", JSON.stringify(userData), options);
        if(response.hasError === true){
            return false;
        }
        else{
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};



export async function forgotResetPasswordApi(userData) {
    try {
        const response = await serviceContext.post("affiliate/forgetpassword", JSON.stringify(userData), options);
        if(response.hasError === true){
            return false;
        }
        else{
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function sendOTP(data) {
    try {
        const response = await serviceContext.post(`affiliate/signup/sendotp`, JSON.stringify(data), options);
        if(response.hasError === true){
            return false;
        }
        else{
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};


export async function getCaptcha() {
    try {
        const response = await serviceContext.get("affiliate/auth/requestcaptcha", null, options);
        if(response.hasError === true){
            return false;
        }
        else{
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};